// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7rpb6","controls":"styles_controls__3sQNj","charLimit":"styles_charLimit__g0s2w","input":"styles_input__15co-","send":"styles_send__qibv8"};